"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Auth = /** @class */ (function () {
    function Auth() {
    }
    Auth.getUser = function () {
        var user = window.localStorage.getItem(Auth.STORAGE_KEY);
        return JSON.parse(user || 'null');
    };
    Auth.setUser = function (user) {
        var userString = JSON.stringify(user);
        window.localStorage.setItem(Auth.STORAGE_KEY, userString);
    };
    Auth.removeUser = function () {
        window.localStorage.removeItem(Auth.STORAGE_KEY);
    };
    Auth.STORAGE_KEY = "user";
    return Auth;
}());
exports.default = Auth;
//# sourceMappingURL=Auth.js.map